import { Box, Card, Grid, Typography } from "@mui/material";
import { Buildings, GlobeHemisphereEast, UsersThree } from "@phosphor-icons/react";
import {
    AmbassadorDetailsButton,
    AppCheckbox,
    LabelWithIcon,
} from "../../../../components/form";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import { isDesktop } from "react-device-detect";

export interface ReviewAmbassadorCardProps {
    ambassador: {
        id?: string;
        title?: string;
        hasPreviousInvitation?: boolean;
        no_of_emp?: string;
        industry?: string;
        region?: string;
        [k: string]: unknown;
    };
    selectable?: boolean;
    limitedAccess?: boolean;
    onSelect?: (ambassador: ReviewAmbassadorCardProps["ambassador"]) => void;
}

const lineClampSx = {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical" as const,
    overflow: "hidden",
};

export default function ReviewAmbassadorCard({
    ambassador,
    selectable = false,
    limitedAccess = false,
    onSelect,
}: ReviewAmbassadorCardProps) {

    return (
        <Card
            sx={{
                background: ambassador.hasPreviousInvitation
                    ? APP_COLORS.successLight2
                    : APP_COLORS.greyLight,
                p: 0,
                height: "auto",
            }}
        >
            <FlexBox alignItems="center" height={70}>
                <Box p={2} sx={{ minWidth: 0 }}>
                    {selectable ? (
                        <AppCheckbox
                            onChange={() => onSelect?.(ambassador)}
                            label={ambassador.title}
                            labelProps={{
                                variant: "body-ibmPlexMono",
                                sx: lineClampSx,
                                title: ambassador.title,
                            }}
                        />
                    ) : (
                        <Typography
                            variant="body-ibmPlexMono"
                            sx={lineClampSx}
                            title={ambassador.title}
                        >
                            {ambassador.title}
                        </Typography>
                    )}
                </Box>
            </FlexBox>

            <Grid
                container
                bgcolor={APP_COLORS.white}
                borderRadius={16 / 12}
                p={2}
                height={135}
            >
                <Grid item xs={12} sm={6} mb={2}>
                    <LabelWithIcon
                        label={ambassador.no_of_emp}
                        icon={<UsersThree size={24} />}
                    />
                </Grid>
                <Grid item xs={12} sm={6} mb={2}>
                    <LabelWithIcon
                        label={ambassador.industry}
                        icon={<Buildings size={24} />}
                        labelProps={{
                            sx: lineClampSx,
                            title: ambassador.industry,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LabelWithIcon
                        label={ambassador.region || "US"}
                        icon={<GlobeHemisphereEast size={24} />}
                    />
                </Grid>
                <Grid item xs={12} sm={6} mt={isDesktop ? 0 : 2}>
                    <AmbassadorDetailsButton
                        data={ambassador}
                        limitedAccess={limitedAccess}
                        showInitiativesNote
                    />
                </Grid>
            </Grid>
        </Card>
    );
}
